<template>
  <svg
    :class="[svgIcon, svgClass]"
    aria-hidden="true"
    ref="svg"
    v-on="$listeners"
  >
    <use ref="use" :xlink:href="iconName"></use>
  </svg>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ""
    },
    bindData: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      svgIcon: "svg-icon"
    };
  },
  mounted() {
    this.handleBindData();
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return this.className;
      } else {
        return "";
      }
    },
    styleExternalIcon() {
      return {
        mask: `url(${this.iconClass}) no-repeat 50% 50%`,
        "-webkit-mask": `url(${this.iconClass}) no-repeat 50% 50%`
      };
    }
  },
  methods: {
    handleBindData() {
      if (this.bindData) {
        if (this.$refs.svg.dataset) {
          for (let key in this.$refs.svg.dataset) {
            this.$refs.use.dataset[key] = this.$refs.svg.dataset[key];
          }
        }
      }
    }
  }
};
</script>
<style scoped>
.svg-icon {
  width: 16px;
  height: 16px;
}
</style>
